import { ArrowUpRight } from "lucide-react";
import Reveal, { SectionHeading } from "@/components/Reveal";

const PROJECTS = [
  {
    testid: "portfolio-project-1",
    title: "Harbour & Co.",
    category: "Hospitality — Website",
    image: "https://images.unsplash.com/photo-1627542557169-5ed71c66ed85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    testid: "portfolio-project-2",
    title: "Maison Noir",
    category: "Fashion — Brand & Cards",
    image: "https://images.pexels.com/photos/38290951/pexels-photo-38290951.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    testid: "portfolio-project-3",
    title: "Still Water Spa",
    category: "Wellness — Website",
    image: "https://images.pexels.com/photos/8408538/pexels-photo-8408538.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    testid: "portfolio-project-4",
    title: "Southline Creative",
    category: "Ours — Brand & Print",
    image: "/sc-leaflet-brand.jpg",
  },
];

export default function Portfolio() {
  return (
    <section id="work" data-testid="portfolio-section" className="py-24 md:py-32 bg-[#0A0A0A] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <SectionHeading
            index="02"
            eyebrow="Selected Work"
            title={<>A taste of the <span className="italic text-gold">standard.</span></>}
          />
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm text-cream/50 font-light leading-relaxed">
              Styled sample projects for now — the real cases land here as each
              launch goes live.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.testid} delay={(i % 2) * 0.12}>
              <article
                data-testid={p.testid}
                className="group relative overflow-hidden border border-white/10 hover:border-gold/40 transition-colors duration-500 aspect-[4/3] cursor-pointer"
              >
                <img
                  src={p.image}
                  alt={`${p.title} — ${p.category}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 transition-colors duration-500 group-hover:bg-black/55" />
                <div className="absolute top-5 left-6">
                  <span className="text-[11px] uppercase tracking-[0.25em] text-cream/70 bg-ink/50 backdrop-blur-sm px-3 py-1.5 border border-white/10">
                    {p.category}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="font-display italic text-3xl md:text-4xl text-cream flex items-center gap-3">
                    View project <ArrowUpRight className="w-6 h-6 text-gold" />
                  </span>
                </div>
                <div className="absolute bottom-5 left-6 right-6 flex items-end justify-between">
                  <h3 className="font-display text-2xl md:text-3xl">{p.title}</h3>
                  <span className="font-display italic text-gold/80 text-lg">0{i + 1}</span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
